import { usePublicConfig } from '../lib/runtimeConfig'
import { formatInstanceCode } from '../lib/native/instanceCode'

/**
 * [Native B1, NB1-11] Formats a shared / personal code for an organizer surface as
 * `<orgId>-<CODE>`, so a code typed into the store app carries its server. The org ID comes from
 * this server's public config; while it is loading, errored, or unset, the bare code is shown
 * (still valid on this server's web /join).
 */
export function useFormatInstanceCode(): (code: string) => string {
  const { data } = usePublicConfig()
  const orgId = data?.organizationId ?? null
  return (code: string) => formatInstanceCode(code, orgId)
}
